import { twMerge } from 'tailwind-merge';

import type { Button } from '@root/sanity/sanity.types';
import IconArrowRight from 'components/IconArrowRight';
import SanityLink from 'components/sanity/Link';

const LINK_ARROW_COLOR: Record<string, string> = {
  'link-arrow-default': 'text-gold-darker',
  'link-arrow-black': 'text-black',
  'link-arrow-white': 'text-white',
};

type SanityButtonProps = Omit<Button, '_type'> & {
  _type?: string;
} & ClassNameProp;

const SanityButton = ({
  className,
  elementLabel,
  href,
  includeQueryString,
  newTab,
  style,
  text,
  trackerClass,
}: SanityButtonProps): JSX.Element | null => {
  if (!href || !text) return null;

  if (style && style in LINK_ARROW_COLOR) {
    const color = LINK_ARROW_COLOR[style];
    return (
      <SanityLink
        href={href}
        className={twMerge(color, trackerClass, className)}
        elementLabel={elementLabel}
        newTab={newTab}
        includeQueryString={includeQueryString}
      >
        <span className="flex items-center">
          <strong>{text}</strong>
          <IconArrowRight className={twMerge('ml-8', color)} />
        </span>
      </SanityLink>
    );
  }

  return (
    <SanityLink
      href={href}
      className={twMerge('btn', style, trackerClass, className)}
      elementLabel={elementLabel}
      newTab={newTab}
      includeQueryString={includeQueryString}
    >
      {text}
    </SanityLink>
  );
};

export default SanityButton;
